import {
  FETCH_BV_QUESTION_ANSWER_REQUEST,
  FETCH_BV_QUESTION_ANSWER_SUCCESS,
  FETCH_BV_QUESTION_ANSWER_FAILURE
} from '../../actionTypes/bazaarVoiceQuestionAnswerActionTypes'

const fetchBVQuestionAnswerRequest = payload => ({
  type: FETCH_BV_QUESTION_ANSWER_REQUEST,
  payload
})

const fetchBVQuestionAnswerSuccess = payload => ({
  type: FETCH_BV_QUESTION_ANSWER_SUCCESS,
  payload
})

const fetchBVQuestionAnswerFailure = payload => ({
  type: FETCH_BV_QUESTION_ANSWER_FAILURE,
  payload
})

export { fetchBVQuestionAnswerRequest, fetchBVQuestionAnswerSuccess, fetchBVQuestionAnswerFailure }
